import React, { useState, useEffect, useCallback } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Divider, Typography, RadioGroup, Grid, IconButton } from "@mui/material";
import { AiOutlineInfoCircle } from "react-icons/ai";
import {
  setSearchFiltersData,
  updateArrayFieldSearchFiltersData,
  updateSearchFiltersData,
  changeSearchFiltersAvailability,
  setSearchResults,
} from "../../slice";
import { BASE_INFOS_API, DEMANDS_INFORMATION_API, MATCH_API, FILTER_API } from "../../api";
import { useDate } from "../../hooks";
import NoResult from "./NoResult";
import Result from "./Result";
import RangeSlider from "../all-inputs/BaseSlider";
import BaseRadio from "../all-inputs/BaseRadio";
import Select from "../Select";
import Input from "../Input";
import BaseCheckbox from "../all-inputs/BaseCheckbox";
import BaseSwitch from "../all-inputs/BaseSwitch";
import AddField from "../form/AddField";
import InfiniteScroll from "../InfiniteScroll";
import BaseTextArea from "../all-inputs/BaseTextArea";
import { BsBox } from "react-icons/bs";
import { HiOutlineTrash } from "react-icons/hi";
import { PALETTE } from "../../Theme/Palette";

function SearchFilters() {
  const PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE;
  const dispatch = useDispatch();
  const { data, isSearchFiltersAvailable } = useSelector((state) => state.SearchFilters);
  const { data: searchResults, isSearchResultAvailable } = useSelector(
    (state) => state.SearchResult
  );
  const { userInfo: userInformation } = useSelector((state) => state.UserCurrentState);
  const { simpleGregorianToPersian } = useDate();
  const [isSearch, setIsSearch] = useState(true);
  const [candidates, setCandidates] = useState([]);
  const [totalMatchCount, setTotalMatchCount] = useState(0);
  const [enabledPriority, setEnabledPriority] = useState("");
  const [isNotMatterPriorityId, setIsNotMatterPriorityId] = useState();
  //! in qsmt nabayad pak beshe ta taklifesh moshakhash beshe
  // const [fitnessTypes, setFitnessTypes] = useState([]);
  const [isSpouseEthnicity, setIsSpouseEthnicity] = useState(false);
  const [otherDemands, setOtherDemands] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const { mutate: search, isLoading } = useMutation((data) =>
    MATCH_API.Search(data.body, data.page * PAGE_SIZE, PAGE_SIZE)
  );

  const handleNextPage = () => {
    let body = { ...data };
    //! in qsmt nabayad pak beshe ta taklifesh moshakhash beshe
    delete body.fitnessCode;
    search(
      { body, page },
      {
        onSuccess: ({ data }) => {
          if (data.success) {
            setIsSearch(false);
            const temp = [];
            data.data.candidates.forEach((item) => {
              let birthDate = simpleGregorianToPersian(
                item.birthDate.split("T").shift()
              ).replaceAll("-", "/");
              temp.push({ ...item, birthDate });
            });
            setPage((prev) => prev + 1);
            setHasMore([...candidates, ...temp].length > data.data.totalMatchCount);
            dispatch(setSearchResults([...candidates, ...temp]));
          }
          setTotalMatchCount(data.data.totalMatchCount);
        },
      }
    );
  };

  const searchCandidates = () => {
    let body = { ...data };
    //! in qsmt nabayad pak beshe ta taklifesh moshakhash beshe
    delete body.fitnessCode;
    if (lookupsData?.data?.data[33000]) {
      lookupsData?.data?.data[33000].forEach((item) => {
        if (body[item.code] === undefined) {
          body[item.code] = false;
        }
      });
    }
    if (lookupsData?.data?.data[42000]) {
      lookupsData?.data?.data[42000].forEach((item) => {
        if (body[item.code] === undefined) {
          body[item.code] = false;
        }
      });
    }
    search(
      { body, page: 0 },
      {
        onSuccess: ({ data }) => {
          if (data.success) {
            setIsSearch(false);
            const temp = [];
            data.data.candidates.forEach((item) => {
              let birthDate = simpleGregorianToPersian(
                item.birthDate.split("T").shift()
              ).replaceAll("-", "/");
              temp.push({ ...item, birthDate });
            });
            setPage(1);
            setHasMore(temp.length > data.data.totalMatchCount);
            dispatch(setSearchResults(temp));
          }
          setTotalMatchCount(data.data.totalMatchCount);
        },
      }
    );
  };

  const handleOtherDemands = (action, index) => {
    switch (action) {
      case "add":
        setOtherDemands((prev) => [...prev, ""]);
        break;
      case "remove":
        let temp = otherDemands.filter((item, i) => i !== index);
        setOtherDemands(temp);
        break;
      default:
        break;
    }
  };

  const handlelivingCityPriority = (livingCityPriority, event) => {
    ["livingCityPriorityOneId", "livingCityPriorityTwoId", "livingCityPriorityThreeId"].forEach(
      (key) => {
        if (key !== livingCityPriority) {
          if (parseInt(event.target.value) === isNotMatterPriorityId) {
            setEnabledPriority(livingCityPriority);
            dispatch(
              updateSearchFiltersData({
                key,
                value: "",
                required: true,
              })
            );
          } else {
            setEnabledPriority("");
          }
        } else {
          dispatch(
            updateSearchFiltersData({
              key,
              value: event.target.value,
              required: true,
            })
          );
        }
      }
    );
  };

  const handleHaveChildrenAllowed = (event) => {
    dispatch(
      updateSearchFiltersData({
        key: "haveChildrenAllowed",
        value: event.target.checked,
        required: true,
      })
    );
    ["childGenderMatter", "childrenCountMatter", "childrenAgeMatter"].forEach((key) => {
      dispatch(
        updateSearchFiltersData({
          key,
          value: false,
          required: true,
        })
      );
    });
  };

  const { data: lookupsData } = useQuery(
    ["getFilterDataCollection_searchFilter"],
    () =>
      FILTER_API.GetFilterDataCollection(
        true,
        [28000, 33000, 42000, 5000, 37000, 13000, 11000, 25000, 26000, 8000, 27000]
      ),
    {
      staleTime: Infinity,
    }
  );

  //! in qsmt nabayad pak beshe ta taklifesh moshakhash beshe
  // useQuery(["getFitnessTypes"], () => LOOKUPS_API.GetFitnessTypes(false), {
  //   onSuccess: ({ data }) => {
  //     if (data.success) {
  //       setFitnessTypes(data.data);
  //     }
  //   },
  // });

  useQuery(["getDemandsInformation"], () => DEMANDS_INFORMATION_API.GetDemandsInformation(), {
    onSuccess: ({ data: DemandsInformation }) => {
      if (DemandsInformation.success && DemandsInformation.data) {
        setOtherDemands(DemandsInformation.data.otherDemands);
        dispatch(setSearchFiltersData(DemandsInformation.data));
        setIsSpouseEthnicity(DemandsInformation.data.spouseEthnicityMatter);
        dispatch(changeSearchFiltersAvailability(true));
        handleGetisNotMatterPriorityId(DemandsInformation.data);
      }
    },
    enabled: !isSearchFiltersAvailable,
  });

  const { data: residencePriorities } = useQuery(["getResidencePriorities"], () =>
    BASE_INFOS_API.GetResidencePrioritiesByCountryId(1)
  );

  const handleGetisNotMatterPriorityId = useCallback(
    (data) => {
      if (data) {
        residencePriorities?.data?.data.forEach(({ isNotMatter, id }) => {
          if (isNotMatter) {
            [
              "livingCityPriorityOneId",
              "livingCityPriorityTwoId",
              "livingCityPriorityThreeId",
            ].forEach((key) => {
              if (parseInt(data[key]) === id) {
                setEnabledPriority(key);
              }
            });
            setIsNotMatterPriorityId(id);
            return;
          }
        });
      }
    },
    [residencePriorities?.data]
  );

  useEffect(() => {
    if (candidates.length !== 0) {
      dispatch(setSearchResults(candidates));
    }
  }, [candidates, dispatch]);

  useEffect(() => {
    if (isSearchResultAvailable) {
      setCandidates(searchResults);
      setTotalMatchCount(searchResults.length);
    }
  }, []);

  useEffect(() => {
    handleGetisNotMatterPriorityId(data);
  }, [residencePriorities?.data?.data]);

  return (
    <>
      <Box
        width="100%"
        borderTop="1px solid #DFDFDF"
        display="flex"
        alignItems="flex-end"
        justifyContent="space-between"
        flexWrap="wrap-reverse"
        pt={4}
      >
        <Box
          width={{ xs: "100%", sm: "100%", md: "54%", lg: "54%" }}
          height="1080px"
          borderRadius={2}
          display={{
            xs: isSearch ? "none" : "flex",
            sm: isSearch ? "none" : "flex",
            md: "flex",
            lg: "flex",
            xl: "flex",
          }}
          flexDirection="column"
          alignItems="center"
          id="scrollable_search"
        >
          <Box
            justifyContent="center"
            width={{ xs: "100%", sm: "100%", md: "58%", lg: "58%" }}
            my={1}
            display={{
              xs: isSearch ? "none" : "flex",
              sm: isSearch ? "none" : "flex",
              md: "none",
              lg: "none",
              xl: "none",
            }}
          >
            <Button variant="s1" onClick={() => setIsSearch(!isSearch)}>
              تغییر پارامترها
            </Button>
          </Box>
          <Box
            border="1px solid #DFDFDF"
            width="100%"
            borderRadius={2}
            flexDirection="column"
            alignItems="center"
            maxHeight="95vh"
            minHeight="95vh"
            sx={{ overflow: "auto" }}
            boxSizing="border-box"
          >
            <Box
              width="100%"
              display={{ xs: "none", sm: "none", md: "flex" }}
              justifyContent="space-between"
              alignItems="center"
              sx={{ boxSizing: "border-box", padding: 2 }}
            >
              <Button
                variant="s1"
                sx={{ minWidth: "90px", whiteSpace: "nowrap" }}
                onClick={searchCandidates}
              >
                جستجو کن
              </Button>
              {totalMatchCount === 0 ? (
                <Typography variant="h2" textAlign="right" float="right">
                  نتایج جستجو
                </Typography>
              ) : (
                <Box display="flex" justifyContent="flex-start" alignItems="center">
                  <Typography
                    variant="h2"
                    textAlign="right"
                    float="right"
                    marginRight="1rem"
                    sx={{ boxSizing: "border-box", paddingLeft: 3 }}
                  >
                    با انتخاب هر کد همسان ، کد انتخابی به لیست "کاندیدهای همسانی" اضافه می‌گردد. در
                    بخش "کاندیدهای همسانی" شما می‌توانید حداکثر 3 گزینه را انتخاب و به مرکز ارسال
                    نمائید.
                  </Typography>
                  <AiOutlineInfoCircle
                    color={PALETTE.eightth}
                    fontSize="1.5rem"
                    style={{ minWidth: "1.3rem" }}
                  />
                </Box>
              )}
            </Box>
            {totalMatchCount === 0 ? (
              isSearch ? (
                <Box display="flex" flexDirection="column" alignItems="center" my={15}>
                  <BsBox color="#c9c8d4" fontSize={50} />
                  <Typography variant="h6" color="#c9c8d4" mt={2}>
                    ...هیچ موردی برای نمایش وجود ندارد
                  </Typography>
                </Box>
              ) : (
                <NoResult />
              )
            ) : (
              <InfiniteScroll
                hasMore={hasMore}
                loadMore={handleNextPage}
                scrollTarget="scrollable_search"
                isLoading={isLoading}
                dataLength={candidates.length}
              >
                <Result data={searchResults} />
              </InfiniteScroll>
            )}
          </Box>
        </Box>
        <Box
          display={{ xs: !isSearch ? "none" : "flex", sm: !isSearch ? "none" : "flex", md: "flex" }}
          flexDirection="column"
          width={{ xs: "100%", sm: "100%", md: "44%" }}
          alignItems="end"
          boxSizing="border-box"
          pl={{ xs: 0, md: 3 }}
        >
          <Box
            width="100%"
            display={{ xs: "flex", sm: "flex", md: "none", lg: "none", xl: "none" }}
            justifyContent="center"
            alignItems="center"
            sx={{ boxSizing: "border-box", padding: 2 }}
          >
            <Button
              variant="s1"
              onClick={() => {
                searchCandidates();
                setIsSearch(!isSearch);
              }}
            >
              جستجو کن
            </Button>
          </Box>
          <Typography variant="h1" marginBottom="2rem">
            مشخصات ظاهری
          </Typography>
          <Grid
            spacing={{ xs: 2, xl: 0 }}
            container
            display="flex"
            justifyContent="space-between"
            flexDirection="row-reverse"
            alignItems="center"
            width="100%"
            marginBottom="2.2rem"
          >
            <Grid item lg={6} md={12} sm={12} xs={12} xl={6.35}>
              <Input
                label="از سال تولد"
                labelFlex={{ xs: 5, sm: 3, md: 5, lg: 5, xl: 5 }}
                flex={{ xs: 5, sm: 5, md: 2.3, lg: 2.3, xl: 1.4 }}
                value={data.fromYear}
                validationType="year"
                type="number"
                id="fromYear"
                name="fromYear"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "fromYear",
                      value: event.target.value,
                      required: false,
                    })
                  )
                }
                placeholder="1400"
              />
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12} xl={5}>
              <Input
                label="تا سال تولد"
                labelFlex={{ xs: 5, sm: 3, md: 5, lg: 5 }}
                flex={{ xs: 5, sm: 5, md: 2.3, lg: 2 }}
                value={data.toYear}
                id="toYear"
                name="toYear"
                type="number"
                validationType="year"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "toYear",
                      value: event.target.value,
                      required: false,
                    })
                  )
                }
                placeholder="1400"
              />
            </Grid>
          </Grid>
          {/* //! in qsmt nabayad pak beshe ta taklifesh moshakhash beshe */}
          {/* <Box width={{ xs: "73%", md: "90%", lg: "70%" }} sx={{ marginBottom: "30px" }}>
            <Select
              label="تناسب اندام"
              id="fitnessCode"
              name="fitnessCode"
              idKey="code"
              labelFlex={5}
              flex={7}
              labelKey="name"
              data={fitnessTypes}
              value={data.fitnessCode}
              onChange={(event) =>
                dispatch(
                  updateSearchFiltersData({
                    key: "fitnessCode",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
            />
          </Box> */}
          <RangeSlider
            value={[data.fromHeight, data.toHeight]}
            onChange={(event, newValue) => {
              dispatch(
                updateSearchFiltersData({
                  key: "fromHeight",
                  value: newValue[0],
                  required: false,
                })
              );
              dispatch(
                updateSearchFiltersData({
                  key: "toHeight",
                  value: newValue[1],
                  required: false,
                })
              );
            }}
            flex={{ xs: 7.5, lg: 5, xl: 3.25 }}
            labelFlex={{ xs: 4.05, lg: 2.05, xl: 2.05 }}
          />
          <Box my={3} width="100%">
            <Divider />
          </Box>
          <Typography variant="h1">وضعیت اعتقادی</Typography>
          <Box my={2} width="100%" display="flex" justifyContent="flex-end">
            <Select
              label="وضعیت اعتقادی"
              //width={"180px"}
              idKey="code"
              labelKey="name"
              value={data.beliefTypeCode}
              onChange={(event) =>
                dispatch(
                  updateSearchFiltersData({
                    key: "beliefTypeCode",
                    value: event.target.value,
                    required: false,
                  })
                )
              }
              flex={7}
              labelFlex={5}
              data={lookupsData?.data?.data[28000]}
            />
          </Box>
          <Box my={2} width="100%" display="flex" justifyContent="flex-end">
            <Select
              label=" گرایش سیاسی"
              //width={"180px"}
              idKey="code"
              labelKey="name"
              value={data.politicalOrientationCode}
              onChange={(event) =>
                dispatch(
                  updateSearchFiltersData({
                    key: "politicalOrientationCode",
                    value: event.target.value,
                    required: false,
                  })
                )
              }
              flex={7}
              labelFlex={5}
              data={lookupsData?.data?.data[5000]}
            />
          </Box>
          <Box my={2} width="100%" display={"flex"} justifyContent="flex-end">
            <Select
              label="وضعیت پوشش"
              //width={"180px"}
              idKey="code"
              labelKey="name"
              value={data.clothingTypeCode}
              onChange={(event) =>
                dispatch(
                  updateSearchFiltersData({
                    key: "clothingTypeCode",
                    value: event.target.value,
                    required: false,
                  })
                )
              }
              flex={7}
              labelFlex={5}
              data={lookupsData?.data?.data[userInformation.genderTypeEnum !== 1 ? 37000 : 13000]}
            />
          </Box>
          <Box my={1} width="100%" display="flex" justifyContent="flex-end">
            <BaseTextArea
              label="توضیحات"
              placeholder="در صورت نیاز توضیح دهید"
              value={data.religionDescription}
              onChange={(event) =>
                dispatch(
                  updateSearchFiltersData({
                    key: "religionDescription",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              flex={{ xs: 6.9, sm: 6.8, lg: 6.85, xl: 6.9 }}
              labelFlex={{ xs: 5.1, sm: 5.2, lg: 5.15, xl: 5.1 }}
            />
          </Box>
          <Box my={3} width="100%">
            <Divider />
          </Box>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h1" marginBottom="0.5rem" align="right">
                وضعیت تحصیلی
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2" letterSpacing={0.5} color="#9995b1">
                شما می‌توانید از بین گزینه‌ها، چند گزینه را انتخاب کنید
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-end"
              xs={12}
            >
              <Typography variant="h2" mt={3} mb={1}>
                سطح تحصیلات
              </Typography>
              {lookupsData?.data?.data[33000].map((educationLevel) => (
                <BaseCheckbox
                  key={educationLevel.code}
                  label={educationLevel.name}
                  checked={Boolean(data[educationLevel.code])}
                  value={educationLevel.code}
                  onChange={(event) =>
                    dispatch(
                      updateSearchFiltersData({
                        key: educationLevel.code,
                        value: event.target.checked,
                        required: true,
                      })
                    )
                  }
                  sx={{
                    padding: "0 0.76rem 0 0",
                    color: "#4C466F",
                  }}
                />
              ))}
            </Grid>
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-end"
              xs={12}
            >
              <Typography flex={1} variant="h2" mt={3} mb={1}>
                شاخه تحصیلی
              </Typography>
              {lookupsData?.data?.data[42000].map((educationBranch) => (
                <BaseCheckbox
                  label={educationBranch.name}
                  checked={Boolean(data[educationBranch.code])}
                  value={educationBranch.code}
                  onChange={(event) =>
                    dispatch(
                      updateSearchFiltersData({
                        key: educationBranch.code,
                        value: event.target.checked,
                        required: true,
                      })
                    )
                  }
                  sx={{
                    padding: "0 0.76rem 0 0",
                    color: "#4C466F",
                  }}
                />
              ))}
            </Grid>
            <Grid item width="100%" marginTop="1.5rem">
              <BaseTextArea
                label="توضیحات"
                placeholder="در صورت نیاز توضیح دهید"
                id="educationDescription"
                name="educationDescription"
                flex={{ xs: 6.9, sm: 6.8, lg: 6.85, xl: 6.9 }}
                labelFlex={{ xs: 5.1, sm: 5.2, lg: 5.15, xl: 5.1 }}
                value={data.educationDescription}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "educationDescription",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
          </Grid>
          <Divider style={{ width: "100%", margin: "15px 0" }} />
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h1" marginBottom="0.5rem" textAlign="right">
                وضعیت تاهل
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2" letterSpacing={0.5} textAlign="right" color="#9995b1">
                شما می‌توانید از بین گزینه‌ها، چند گزینه را انتخاب کنید
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2" my={2}>
                وضعیت تاهل و فرزندان همسر
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-end"
              xs={12}
              pr="0.76rem"
            >
              <BaseCheckbox
                label="مجرد"
                checked={data.spouseSingle}
                value="spouseSingle"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseSingle",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="عقد ناموفق (جدایی یا فوت)"
                checked={data.spouseUnsuccessfulContract}
                value="spouseUnsuccessfulContract"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseUnsuccessfulContract",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="جدا شده"
                checked={data.spouseDivorced}
                value="spouseDivorced"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseDivorced",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="همسر فوت شده"
                checked={data.spouseDeceased}
                value="spouseDeceased"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseDeceased",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="همسر شهید"
                checked={data.spouseMartyr}
                value="spouseMartyr"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseMartyr",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-end"
              xs={12}
              pr="0.76rem"
            >
              <BaseCheckbox
                label="فرزند/فرزندان همسر را می‌پذیرم"
                checked={data.haveChildrenAllowed}
                value="haveChildrenAllowed"
                onChange={(event) => handleHaveChildrenAllowed(event)}
              />
              <BaseCheckbox
                label="جنسیت فرزند/فرزندان مهم است"
                checked={data.childGenderMatter}
                disabled={!data.haveChildrenAllowed}
                value="childGenderMatter"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "childGenderMatter",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="تعداد فرزند/فرزندان مهم است"
                checked={data.childrenCountMatter}
                disabled={!data.haveChildrenAllowed}
                value="childrenCountMatter"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "childrenCountMatter",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="سن فرزند/فرزندان مهم است"
                checked={data.childrenAgeMatter}
                disabled={!data.haveChildrenAllowed}
                value="childrenAgeMatter"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "childrenAgeMatter",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12}>
              <BaseTextArea
                label="توضیحات"
                placeholder="شرایط پذیرش فرزند/فرزندان همسر را توضیح دهید"
                id="marriageDescription"
                name="marriageDescription"
                flex={{ xs: 6.9, sm: 6.8, lg: 6.85, xl: 6.9 }}
                labelFlex={{ xs: 5.1, sm: 5.2, lg: 5.15, xl: 5.1 }}
                value={data.marriageDescription}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "marriageDescription",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            {/* //! in qsmt nabayad pak beshe ta taklifesh moshakhas beshe */}
            {/* <Divider style={{ width: "100%", margin: "15px 0" }} />
            <Grid item xs={12}>
              <Typography variant="h1" marginBottom="0.5rem" textAlign="right">
                اطلاعات جانبی
              </Typography>
            </Grid>
            <Grid item xs={12} marginBottom="1rem">
              <Typography variant="h2" letterSpacing={0.5} textAlign="right" color="#9995b1">
                شما می‌توانید از بین گزینه‌ها، چند گزینه را انتخاب کنید
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="column" alignItems="flex-end" xs={12}>
              <BaseCheckbox
                label="همسرم مصرف کننده سیگار نباشد"
                checked={data.spouseNotSmoker}
                value="spouseNotSmoker"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseNotSmoker",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="با استعمال قلیان مشکلی ندارم"
                checked={data.hookahAllowed}
                value="hookahAllowed"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "hookahAllowed",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label={"تمایل دارم همسرم ورزشکار باشد"}
                checked={data.spouseMustBeAthlete}
                value="spouseMustBeAthlete"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseMustBeAthlete",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
              <BaseCheckbox
                label="تمایل دارم همسرم اهل هنر باشد"
                checked={data.spouseMustBeArtist}
                value="spouseMustBeArtist"
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseMustBeArtist",
                      value: event.target.checked,
                      required: true,
                    })
                  )
                }
              />
            </Grid> */}
            <Divider style={{ width: "100%", margin: "15px 0" }} />
          </Grid>
          <Typography variant="h1" my={1}>
            وضعیت سکونت
          </Typography>
          <Typography variant="h2" my={1} textAlign="right">
            استان‌هایی که بعداز ازدواج مایل به سکونت در آن‌ها هستید مشخص نمایید
          </Typography>
          <Box my={1} width="100%" display="flex" justifyContent="flex-end">
            <Select
              label="اولویت اول"
              idKey="id"
              labelKey="name"
              value={data.livingCityPriorityOneId}
              flex={7}
              labelFlex={5}
              data={residencePriorities?.data?.data}
              disabled={enabledPriority !== "" && enabledPriority !== "livingCityPriorityOneId"}
              onChange={(event) => handlelivingCityPriority("livingCityPriorityOneId", event)}
            />
          </Box>
          <Box my={1} width="100%" display="flex" justifyContent="flex-end">
            <Select
              label="اولویت دوم"
              idKey="id"
              labelKey="name"
              value={data.livingCityPriorityTwoId}
              flex={7}
              labelFlex={5}
              data={residencePriorities?.data?.data}
              disabled={enabledPriority !== "" && enabledPriority !== "livingCityPriorityTwoId"}
              onChange={(event) => handlelivingCityPriority("livingCityPriorityTwoId", event)}
            />
          </Box>
          <Box my={1} width="100%" display="flex" justifyContent="flex-end">
            <Select
              label="اولویت سوم"
              idKey="id"
              labelKey="name"
              value={data.livingCityPriorityThreeId}
              flex={7}
              labelFlex={5}
              data={residencePriorities?.data?.data}
              disabled={enabledPriority !== "" && enabledPriority !== "livingCityPriorityThreeId"}
              onChange={(event) => handlelivingCityPriority("livingCityPriorityThreeId", event)}
            />
          </Box>
          <Typography variant="h2" my={2}>
            اقامت در خارج از کشور
          </Typography>
          <RadioGroup
            value={data.residenceAbroadTypeCode}
            onChange={(event) =>
              dispatch(
                updateSearchFiltersData({
                  key: "residenceAbroadTypeCode",
                  value: event.target.value,
                  required: false,
                })
              )
            }
          >
            {lookupsData?.data?.data[8000].map((type) => (
              <BaseRadio text={type.name} value={type.code} key={type.code} />
            ))}
          </RadioGroup>
          <Grid container flexDirection="row-reverse">
            <Divider style={{ width: "100%", margin: "15px 0" }} />
            <Grid item xs={12} sx={Style.itemGrid}>
              <Typography variant="h1" my={1} align="right">
                سایر خواسته‌ها
              </Typography>
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Select
                label="وضعیت اقتصادی همسر"
                idKey="code"
                id="spouseEconomicMatterCode"
                name="spouseEconomicMatterCode"
                data={lookupsData?.data?.data[11000]}
                value={data.spouseEconomicMatterCode}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseEconomicMatterCode",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
                labelFlex={5}
                flex={7}
              />
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Select
                label="وضعیت شغلی همسر"
                id="spouseWorkingMatterCode"
                name="spouseWorkingMatterCode"
                idKey="code"
                flex={7}
                labelFlex={5}
                data={lookupsData?.data?.data[25000]}
                value={data.spouseWorkingMatterCode}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseWorkingMatterCode",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h2" my={2} textAlign="right">
                آیا قومیت همسر مهم است؟
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              justifyContent="flex-start"
              flexDirection={{
                xs: "column",
                sm: "row-reverse",
                md: "row-reverse",
                lg: "row-reverse",
              }}
              xs={12}
              sx={Style.itemGrid}
            >
              <Grid item display="flex" justifyContent="flex-end" xs={12} sx={Style.itemGrid}>
                <RadioGroup
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      sm: "row-reverse",
                    },
                    alignItems: { xs: "end", sm: "center", md: "center" },
                    width: { xs: "100%" },
                  }}
                  value={data.spouseEthnicityMatter}
                  onChange={(event) => {
                    dispatch(
                      updateSearchFiltersData({
                        key: "spouseEthnicityMatter",
                        value: event.target.value,
                        required: true,
                      })
                    );

                    setIsSpouseEthnicity(event.target.value === "true");
                    if (event.target.value === "false")
                      dispatch(
                        updateArrayFieldSearchFiltersData({
                          key: "spouseEthnicityCodes",
                          value: undefined,
                          required: true,
                          reset: true,
                        })
                      );
                  }}
                >
                  <BaseRadio text="بله" value={true} />
                  <BaseRadio
                    text="خیر"
                    value={false}
                    containerStyle={{
                      margin: { sm: "0 1.7rem 0 0" },
                    }}
                  />
                </RadioGroup>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {isSpouseEthnicity && (
                <Grid
                  container
                  display="flex"
                  flexDirection="column"
                  alignContent="flex-start"
                  flexWrap={{ xs: "nowrap", sm: "wrap", lg: "wrap", xl: "wrap" }}
                  height={{ sm: 200, lg: 200, xl: 200 }}
                  sx={{ direction: "rtl" }}
                  mb={3}
                >
                  {lookupsData?.data?.data[26000].map(({ code, name }) => (
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      md={3}
                      lg={3}
                      width={{ xs: "100%", sm: "100%", lg: "33%", xl: "33%" }}
                      key={code}
                      display="flex"
                      flexDirection="flex-start"
                      justifyContent="flex-end"
                      alignItems="flex-start"
                      sx={{ direction: "ltr" }}
                    >
                      <BaseCheckbox
                        label={name}
                        id={code}
                        name={code}
                        checked={
                          data.spouseEthnicityCodes
                            ? data?.spouseEthnicityCodes.includes(`${code}`)
                            : false
                        }
                        value={name}
                        onChange={(event) => {
                          dispatch(
                            updateArrayFieldSearchFiltersData({
                              key: "spouseEthnicityCodes",
                              value: event.target.checked,
                              required: true,
                              code: code,
                              reset: false,
                            })
                          );
                        }}
                        sx={{
                          paddingRight: "1.22rem",
                          // color: "#4C466F",
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Typography variant="h2" marginTop="1rem" textAlign="right">
                اگر خانواده همسر در استان/شهر دیگری زندگی کنند می‌پذیرید؟
              </Typography>
            </Grid>
            <Grid item display="flex" justifyContent="flex-end" xs={12} sx={Style.itemGrid}>
              <RadioGroup
                sx={{
                  display: "flex",
                  flexDirection: {
                    xs: "column-reverse",
                    sm: "row",
                  },
                  alignItems: { xs: "end", sm: "center", md: "center" },
                  justifyContent: "flex-end",
                  width: { xs: "100%" },
                }}
                value={data.spouseFamilyInOtherCityAllowed}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseFamilyInOtherCityAllowed",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              >
                <BaseRadio
                  text="خیر"
                  value={false}
                  containerStyle={{
                    margin: { sm: "0 1.7rem 0 0" },
                  }}
                />
                <BaseRadio text="بله" value={true} />
              </RadioGroup>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h2" my={2} textAlign="right">
                آیا شغل نظامی همسر را می‌پذیرید؟
              </Typography>
            </Grid>
            <Grid item display="flex" justifyContent="flex-end" xs={12} sx={Style.itemGrid}>
              <RadioGroup
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row", md: "row" },
                  alignItems: { xs: "end", sm: "center", md: "center" },
                }}
                value={data.spouseMilitaryAllowed}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseMilitaryAllowed",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              >
                <BaseRadio
                  text="خیر"
                  value={false}
                  containerStyle={{
                    margin: { sm: "0 1.7rem 0 0" },
                  }}
                />
                <BaseRadio text="بله" value={true} />
              </RadioGroup>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h2" my={2} textAlign="right">
                آیا روحانی/طلبه ملبس را می‌پذیرید؟
              </Typography>
            </Grid>
            <Grid item display="flex" justifyContent="flex-end" xs={12} sx={Style.itemGrid}>
              <RadioGroup
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row", md: "row" },
                  alignItems: { xs: "end", sm: "center", md: "center" },
                }}
                value={data.spouseSpiritualAllowed}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spouseSpiritualAllowed",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              >
                <BaseRadio
                  text="خیر"
                  value={false}
                  containerStyle={{
                    margin: { sm: "0 1.7rem 0 0" },
                  }}
                />
                <BaseRadio text="بله" value={true} />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2" my={2} textAlign="right">
                چه نوع شخصیتی را برای همسر می‌پذیرید؟
              </Typography>
            </Grid>
            <Grid item display="flex" justifyContent="flex-end" xs={12}>
              <RadioGroup
                sx={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  alignItems: { xs: "flex-end", sm: "center", md: "center" },
                }}
                value={data.spousePersonalityCode}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "spousePersonalityCode",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              >
                <Grid container flexDirection="row-reverse">
                  {lookupsData?.data?.data[27000].map((item) => (
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      md={5}
                      lg={3}
                      sx={{
                        whiteSpace: { xs: "normal", sm: "nowrap" },
                        marginLeft: { xs: 0, md: "0.15rem", lg: 0 },
                      }}
                    >
                      <BaseRadio text={item.name} value={item.code} />
                    </Grid>
                  ))}
                </Grid>
              </RadioGroup>
            </Grid>
            <Divider style={{ width: "100%", margin: "15px 0" }} />
          </Grid>
          <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "900px" }}>
            <Grid item display="flex" justifyContent="flex-end" xs={12}>
              <Typography variant="h2" textAlign="right">
                می خواهم مرکز با شخص دیگری برای هماهنگی ها تماس بگیرد.
                <br />( به عنوان مثال : مادر یا اعضای خانواده، فامیل )
              </Typography>
              <BaseSwitch
                checked={!data.isContactMe}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "isContactMe",
                      value: !event.target.checked,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Typography variant="h1" my={2} textAlign="right">
                اطلاعات تماس معتمد
              </Typography>
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Input
                label="نام"
                placeholder="نام"
                id="trustedFirstName"
                name="trustedFirstName"
                labelFlex={5}
                flex={7}
                disabled={data.isContactMe}
                value={data.trustedFirstName}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "trustedFirstName",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Input
                placeholder=" نام خانوادگی"
                label="نام خانوادگی"
                id="trustedLastName"
                name="trustedLastName"
                labelFlex={5}
                flex={7}
                disabled={data.isContactMe}
                value={data.trustedLastName}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "trustedLastName",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Input
                label="نسبت"
                placeholder="نسبت"
                id="trustedRelation1"
                name="trustedRelation1"
                labelFlex={5}
                flex={7}
                disabled={data.isContactMe}
                value={data.trustedRelation1}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "trustedRelation1",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Input
                label="تلفن ثابت (‌اختیاری) "
                placeholder="تلفن ثابت (‌اختیاری) "
                id="trustedLandNumber"
                name="trustedLandNumber"
                labelFlex={5}
                flex={7}
                type="number"
                disabled={data.isContactMe}
                value={data.trustedLandNumber}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "trustedLandNumber",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sx={Style.itemGrid}>
              <Input
                label="تلفن همراه"
                placeholder="تلفن همراه"
                id="trustedMobileNumber"
                name="trustedMobileNumber"
                labelFlex={5}
                flex={7}
                type="number"
                disabled={data.isContactMe}
                value={data.trustedMobileNumber}
                onChange={(event) =>
                  dispatch(
                    updateSearchFiltersData({
                      key: "trustedMobileNumber",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
              />
            </Grid>
            <Divider style={{ width: "100%", margin: "15px 0" }} />
            <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
                <Typography variant="h1" textAlign="right">
                  زمان مصاحبه
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
                <Typography variant="h2" textAlign="right">
                  لطفا زمان هایی که در طول هفته جهت حضور در جلسه مصاحبه برای شما مناسب است را
                  بنویسید.
                </Typography>
                <Typography variant="h2" textAlign="right">
                  (بجز پنجشنبه ، جمعه، تعطیلات رسمی)
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
                <BaseTextArea
                  label=""
                  placeholder="در صورت نیاز توضیح دهید"
                  id="firstInterviewDescription"
                  name="firstInterviewDescription"
                  flex={{ xs: 6.7, sm: 9.7, md: 9.7, lg: 9.7 }}
                  labelFlex={{ xs: 5, sm: 2.5, md: 2.5, lg: 2.5 }}
                  value={data.firstInterviewDescription}
                  onChange={(event) =>
                    dispatch(
                      updateSearchFiltersData({
                        key: "firstInterviewDescription",
                        value: event.target.value,
                        required: true,
                      })
                    )
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h1" my={2} textAlign="right">
                سایر ملاک‌های خود را براساس اولویت اضافه نمایید
              </Typography>
            </Grid>
            {otherDemands.map((item, index) => (
              <Grid
                key={index}
                marginBottom="0.7rem"
                display="flex"
                flexDirection="row-reverse"
                item
                xs={12}
              >
                <Box flex={1}>
                  <BaseTextArea
                    label={`اولویت ${index + 1}`}
                    placeholder="اولويت خود را توضيح دهيد"
                    id={`order_${index}`}
                    name={`order_${index}`}
                    labelFlex={{ xs: 1, sm: 2, md: 2, lg: 2 }}
                    flex={{ xs: 4, sm: 6, md: 8, lg: 10 }}
                    value={item}
                    onChange={(event) => {
                      setOtherDemands((prev) => {
                        const newList = [...prev];
                        newList[index] = event.target.value;
                        return newList;
                      });
                    }}
                  />
                </Box>
                <IconButton
                  sx={{
                    backgroundColor: "#EAEAEA",
                    borderRadius: "0.6rem",
                    marginRight: "1.5rem",
                  }}
                  onClick={handleOtherDemands.bind(this, "remove", index)}
                >
                  <HiOutlineTrash />
                </IconButton>
              </Grid>
            ))}
            <AddField
              handleAdd={handleOtherDemands.bind(this, "add", 0)}
              title="اضافه کردن ملاک انتخاب همسر"
            />
          </Grid>
        </Box>
      </Box>
    </>
  );
}

const Style = {
  itemGrid: {
    boxSizing: "border-box",
    paddingLeft: { xs: 0, sm: "0.5rem", md: "1rem", lg: "1rem" },
    marginBottom: "0.7rem",
  },
};

export default SearchFilters;
